import { useConsolidationPreference } from "./useConsolidationView.js";

export default function useConsolidationGeotabDisplay() {
  const [showRoutes, setShowRoutes] = useConsolidationPreference("geotab_routes", true);
  const [showLoadingGaps, setShowLoadingGaps] = useConsolidationPreference("geotab_loading_gaps", true);
  const [showDeliveryGaps, setShowDeliveryGaps] = useConsolidationPreference("geotab_delivery_gaps", true);
  return { showRoutes, setShowRoutes, showLoadingGaps, setShowLoadingGaps, showDeliveryGaps, setShowDeliveryGaps };
}
